module.exports = __webpack_public_path__ + "img/1.2b3699ec.jpg";